export { default as logo } from './logo.png';
export { default as logo2x } from './logo2x.png';
export { default as logo3x } from './logo3x.png';
